import React, { Component } from "react";

class NotFound extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <div className="alert alert-danger">Not found...</div>
      </React.Fragment>
    );
  }
}

export default NotFound;
